package com.shadowings.gero.data.lessons.chapter16

import com.shadowings.gero.data.lessons.calculateNounAdjectivePhrases
import com.shadowings.gero.data.repository.AdjectivePairs
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_1
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_10
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_11
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_12
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_13
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_14
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_15
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_16
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_17
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_18
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_2
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_3
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_4
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_5
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_6
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_7
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_8
import gero.composeapp.generated.resources.exp_content_aggettivi_genere_9
import gero.composeapp.generated.resources.exp_title_aggettivi_genere
import gero.composeapp.generated.resources.quiz_aggettivi_genere_tf_1
import gero.composeapp.generated.resources.quiz_aggettivi_genere_tf_2
import gero.composeapp.generated.resources.quiz_aggettivi_genere_tf_3
import gero.composeapp.generated.resources.quiz_aggettivi_genere_tf_4
import kotlin.random.Random

fun getAggettiviGenereContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_1,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_2,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_3,
            face = Faces.Doubt,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_4,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_5,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_6,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_7,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_8,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_9,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_10,
            face = Faces.Happy,
            character = Characters.Zeta,
            composable = mdcSlide("T18-G43-A1-M17-N29:D21:Y1"),
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_11,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_12,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_13,
            face = Faces.Doubt,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_14,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_15,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = mdcSlide("D21:V13-A1-F35"),
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_16,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = mdcSlide("O34h0.5:X1*B1-F35h2:X1"),
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_17,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_genere,
            content = Res.string.exp_content_aggettivi_genere_18,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
    )
}

// 4 translations + 4 "pick the right hieroglyphs", half masculine and half feminine,
// + 2 true/false on the rule.
fun getAggettiviGenereQuizContent(
    words: List<Word>,
    languageCode: String,
    random: Random = Random,
    adjectivePairs: List<AdjectivePairs> = DatabaseRepositoryImpl.adjectivePairs
): List<IQuizContent> {
    val phrases = calculateNounAdjectivePhrases(words, adjectivePairs, languageCode, plural = false)
    val (translate, choose) = pickPerGender(phrases, listOf(2, 2), random)
    val theory = listOf(
        TrueFalseContent(Res.string.quiz_aggettivi_genere_tf_1, false),
        TrueFalseContent(Res.string.quiz_aggettivi_genere_tf_2, true),
        TrueFalseContent(Res.string.quiz_aggettivi_genere_tf_3, false),
        TrueFalseContent(Res.string.quiz_aggettivi_genere_tf_4, true),
    ).shuffled(random).take(2)

    return (
        buildAdjectiveAgreementQuizzes(
            translate = translate,
            choose = choose,
            pool = phrases,
            includeNumber = false,
            languageCode = languageCode,
            random = random
        ) + theory
        ).shuffled(random)
}
